<div>
    <div>
        <h4 class="ap-green">Site List (Plant)</h4>
        <dx-accordion #accordion [collapsible]="true" [dataSource]="dataAccordion" [multiple]="false"
            [animationDuration]="300" [selectedItems]="[dataAccordion[0]]">
            <div class="ap-green-btn" *dxTemplate="let filter of 'title'">
                <h5>{{ filter.header }}</h5>
            </div>
            <div *dxTemplate="let company of 'item'">
                <div>
                    <table style="width: 100%;">
                        <tr style="margin-top:15px ;">
                            <td class="col-sm-12">
                                <div class="card">
                                    <div class="card-body">
                                        <h5 class="card-title">Check it!</h5>
                                        <div class="table-responsive">
                                            <table style="width : 100%">
                                                <tr style="height: 25px;">
                                                    <td>
                                                        <div class="dx-field">
                                                            <div class="dx-field-label">
                                                                <dx-check-box [(value)]="filtercriteriaobj.isLox"
                                                                    text="LOX/LIN">
                                                                </dx-check-box>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="dx-field">
                                                            <div class="dx-field-label">
                                                                <dx-check-box [(value)]="filtercriteriaobj.isLar"
                                                                    text="LAR">
                                                                </dx-check-box>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="dx-field">
                                                            <div class="dx-field-label">
                                                                <dx-check-box [(value)]="filtercriteriaobj.isCO2"
                                                                    text="CO2">
                                                                </dx-check-box>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="dx-field">
                                                            <div class="dx-field-label">
                                                                <dx-check-box [(value)]="filtercriteriaobj.isHelium"
                                                                    text="Helium">
                                                                </dx-check-box>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="dx-field">
                                                            <div class="dx-field-label">
                                                                <dx-check-box [(value)]="filtercriteriaobj.isHydrogen"
                                                                    text="Hydrogen (Liq and Blk)">
                                                                </dx-check-box>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr style="height: 25px;">
                                                    <td>
                                                        <div class="dx-field">
                                                            <div class="dx-field-label">
                                                                <dx-check-box [(value)]="filtercriteriaobj.isSOE"
                                                                    text="SOE">
                                                                </dx-check-box>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="dx-field">
                                                            <div class="dx-field-label">
                                                                <dx-check-box [(value)]="filtercriteriaobj.isSOG"
                                                                    text="SOG">
                                                                </dx-check-box>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="dx-field">
                                                            <div class="dx-field-label">
                                                                <dx-check-box [(value)]="filtercriteriaobj.isHyco"
                                                                    text="HYCO">
                                                                </dx-check-box>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="dx-field">
                                                            <div class="dx-field-label">
                                                                <dx-check-box [(value)]="filtercriteriaobj.isAsu"
                                                                    text="ASU">
                                                                </dx-check-box>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="dx-field">
                                                            <div class="dx-field-label">
                                                                <dx-check-box [(value)]="filtercriteriaobj.isGeneral"
                                                                    text="General">
                                                                </dx-check-box>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="col-sm-12">
                                <div id="specifics" class="card">
                                    <div class="card-body">
                                        <h5 class="card-title">Specifics!</h5>
                                        <div>
                                            <div class="dx-field">
                                                <div style="width: 10%" class="dx-field-label">Select Country</div>
                                                <div>
                                                    <dx-select-box #selectBox [dataSource]="countiesDataSource"
                                                        [acceptCustomValue]="true" displayExpr="countryName"
                                                        valueExpr="countryId" [(value)]="filtercriteriaobj.countryId"
                                                        [searchEnabled]="true">
                                                    </dx-select-box>
                                                </div>
                                            </div>
                                            <div class="dx-field">
                                                <div style="width: 10%" class="dx-field-label">Production Activity</div>
                                                <div class="dx-field-value">
                                                    <dx-tag-box [dataSource]="productActivitiesData"
                                                        valueExpr="productionActivityName"
                                                        (onValueChanged)="onFilterSelected()"
                                                        [(value)]="filtercriteriaobj.prodActivity" [grouped]="false"
                                                        displayExpr="productionActivityName" [searchEnabled]="true">
                                                    </dx-tag-box>
                                                </div>
                                            </div>
                                            <div class="dx-field">
                                                <div style="width: 10%" class="dx-field-label">Specific Process</div>
                                                <div class="dx-field-value">
                                                    <dx-tag-box [dataSource]="specificProcessData"
                                                        valueExpr="specificProcessName"
                                                        (onValueChanged)="onFilterSelected()"
                                                        [(value)]="filtercriteriaobj.specificProcess" [grouped]="false"
                                                        displayExpr="specificProcessName" [searchEnabled]="true">
                                                    </dx-tag-box>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" class="col-sm-12">
                                <div class="btndiv">
                                    <dx-button class="ap-blue-btn" (onClick)="getPlants()" text="Find Results">
                                    </dx-button>
                                    <dx-button class="ap-blue-btn" (onClick)="ClearFilters()" text="Clear"></dx-button>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </dx-accordion>
        <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
            [shading]="false" [closeOnOutsideClick]="false">
        </dx-load-panel>
        <app-googlemaps [buttonTrigger]="mapsPopupVisible" [isReadOnly]="true" [Coordinates]="Coordinates"
             (setmapsPopupVisibility)="setmapsPopupVisibility($event)">
        </app-googlemaps>
        <dx-data-grid id="gridContainer" class="fixGridHeight" (onSelectionChanged)="siteSelectionChanged($event)"
            [dataSource]="dataSource" [allowColumnReordering]="true" [showRowLines]="true" [showColumnLines]="true"
            [showBorders]="true" [columnAutoWidth]="true" [rowAlternationEnabled]="true" [columnHidingEnabled]="false"
            [allowColumnResizing]="false">
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-filter-panel [visible]="true"></dxo-filter-panel>
            <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
            <dxo-export [enabled]="true"></dxo-export>
            <dxo-selection mode="single" showCheckBoxesMode="always"></dxo-selection>
            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
            <dxo-pager [visible]="true" [allowedPageSizes]="allowedPageSizes" [showPageSizeSelector]="true"
                [showInfo]="true" [showNavigationButtons]="true">
            </dxo-pager>
            <dxo-toolbar>
                <dxi-item name="groupPanel"></dxi-item>
                <dxi-item location="after">
                    <dx-button [disabled]="!isMapViewAvailable" class="ap-blue-btn" text="View On Map"
                        (onClick)="mapview()">
                    </dx-button>
                    <dx-button [disabled]="!isAnySiteSelected"
                        *ngIf="sharedSvc.UserRoles && (sharedSvc.UserRoles['isIGAdmin'] || sharedSvc.UserRoles['isTGEEAdmin'])"
                        class="ap-blue-btn" text="Add New Facility" (onClick)="addNewFacility()">
                    </dx-button>
                    <dx-button [disabled]="!isAnyFacilitySelected" class="ap-blue-btn" text="Edit Facility"
                        (onClick)="editFacility()">
                    </dx-button>
                    <dx-button
                        *ngIf="sharedSvc.UserRoles && (sharedSvc.UserRoles['isIGAdmin'] || sharedSvc.UserRoles['isTGEEAdmin'])"
                        class="ap-blue-btn" text="Add New Site" (onClick)="redirectToAddNew()">
                    </dx-button>
                    <dx-button [disabled]="!isAnySiteSelected" class="ap-blue-btn" text="Edit Site"
                        (onClick)="redirectToEditPage()">
                    </dx-button>
                    <dx-button class="ap-blue-btn" text="Reset" (onClick)="resetFilters()">
                    </dx-button>
                    <dx-button icon="exportxlsx" class="ap-blue-btn" (onClick)="exportExcel($event)"
                        text="Export to Excel">
                    </dx-button>
                </dxi-item>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>
            <dxi-column dataField="plantBusiness" caption="Plant Business"></dxi-column>
            <dxi-column dataField="activeFlag" caption="Is Site Active"></dxi-column>
            <dxi-column dataField="siteName" caption="Site Name"></dxi-column>
            <dxi-column dataField="ownerSub" caption="Owner (Subsidiary)"></dxi-column>
            <dxi-column dataField="owner" caption="Owner (Parent)"></dxi-column>
            <dxi-column dataField="address" caption="Address EN"></dxi-column>
            <dxi-column dataField="city" caption="City"></dxi-column>
            <dxi-column dataField="province" caption="State/Province"></dxi-column>
            <dxi-column dataField="postalCode" caption="Postal Code"></dxi-column>
            <dxi-column dataField="countryName" caption="Country"></dxi-column>
            <dxi-column dataField="activityProcessFeedstockIndustry" caption="Activity Process Feedstock Industry">
            </dxi-column>
            <dxi-column dataField="status" caption="Facility Status"></dxi-column>
            <dxi-column dataField="onstreamYear" caption="Onstream Year"></dxi-column>
            <dxi-column dataField="primaryProduct" caption="Primary Product"></dxi-column>
            <dxi-column dataField="capacity" caption="Capacity"></dxi-column>
            <dxi-column dataField="capacityUOM" caption="Capacity UOM"></dxi-column>
            <dxi-column dataField="latitude" [visible]="false" caption="Latitude"></dxi-column>
            <dxi-column dataField="longitude" [visible]="false" caption="Longitude"></dxi-column>
            <dxi-column dataField="siteId" caption="Site ID"></dxi-column>
            <dxi-column dataField="productionFacilityId" caption="Facility ID"></dxi-column>
            <dxi-column dataField="liquifierType" caption="Liquifier Type"></dxi-column>
            <dxi-column dataField="hostCustomer" caption="Host Customer"></dxi-column>
            <dxi-column dataField="shutdownDate" caption="Shutdown Date" dataType="date" format="MM/dd/yyyy"></dxi-column>
            <dxi-column dataField="modifiedBy" [visible]="false" caption="Site Modified By"></dxi-column>
            <dxi-column dataField="modifiedDate" [visible]="false" caption="Modified On"></dxi-column>
            <dxi-column dataField="insertedBy" [visible]="false" caption="Inserted By"></dxi-column>
            <dxi-column dataField="insertedDate" [visible]="false" caption="Inserted On"></dxi-column>
            <div *dxTemplate="let data of 'cellTemplate'">
                <a routerLink="." (click)="redirectToEditPage(data.row)"
                    class="dx-link dx-link-edit dx-icon-edit dx-link-icon" title="Edit"></a>
            </div>
        </dx-data-grid>
    </div>
</div>